<div class="events-listing-container listing-full-size">
  <cdk-virtual-scroll-viewport *ngIf="['trainers'].includes(state)"
                               itemSize="typicalItemHeight" minBufferPx="300" maxBufferPx="600"
                               class="cdk-scroll">
    <app-listing-item *cdkVirtualFor="let listItem of listing.listItems;" [listItem]="listItem"
                      [activeItemCounter]="listing.selectedListItems.length"
                      (click)="clickOnItem($event, listItem)">
    </app-listing-item>
  </cdk-virtual-scroll-viewport>

  <cdk-virtual-scroll-viewport *ngIf="['trainers_widget'].includes(state)"
                               itemSize="typicalItemHeight" minBufferPx="300" maxBufferPx="600"
                               class="cdk-scroll">
    <app-trainer-item *cdkVirtualFor="let listItem of listing.listItems;" [listItem]="listItem"
                      (click)="clickOnItem($event, listItem)">
    </app-trainer-item>
  </cdk-virtual-scroll-viewport>

  <cdk-virtual-scroll-viewport *ngIf="['cup_players_view'].includes(state)"
                               itemSize="typicalItemHeight" minBufferPx="300" maxBufferPx="600"
                               class="cdk-scroll">
    <div style="height: 8px"><!--first row badge fix--></div>
    <app-cup-player-item *cdkVirtualFor="let listItem of listing.listItems;"
                         [listItem]="listItem"></app-cup-player-item>
  </cdk-virtual-scroll-viewport>

  <div *ngIf="state === 'loading'" class="internal-spinner">
    <svg class="spinner" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
    </svg>
  </div>
</div>
